<template lang="pug">
  div
    div.d-flex.justify-center.mt-16(v-if="isFetching")
      v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
    template(v-else)
      v-card-text.neutral700--text.pa-8(outlined)
        v-row(justify="center" :style="`min-height: ${viewHeight};`")
          v-col(cols="9")
            div.mb-6
              div.d-flex.align-center
                v-btn.mr-2(icon color="neutral700" @click="goBack")
                  v-icon(color="neutral700" :size="24") mdi-close
                .text-2xl.font-semibold {{ offer.name }}
              .text-md.ml-4 {{ getPreset().subtitle }}
            // Preset title
            v-card.round-xl.content-box.pa-6(outlined)
              div.d-flex.align-center
                div
                  div.text-md.font-semibold.neutral700--text {{ offer.name }}
                  div.text-sm.neutral700--text {{ getPreset().contentDescription }}
                v-spacer
                div
                  y-switch.mb-n3(v-model="rewardStatus")
            template(v-if="rewardStatus")
              v-form(ref="form")
                // Setup
                v-card.round-xl.content-box.pa-6.mt-4(outlined)
                  //- Offers reward
                  div.text-md.font-semibold.neutral700--text Offers reward
                  .text-sm.neutral700--text(style="margin-top: 2px;") Setup your offers reward
                  v-radio-group.mt-0(v-model="offer.reward_type" @change="sanitizeUnusedObject(['discount_percentage', 'discount_amount', 'free_item_type', 'free_item_name'], ['free_products'])")
                    v-row(no-gutters)
                      v-col(cols="6")
                        v-radio.mt-3(value="discount_percentage" color="neutral700")
                          template(v-slot:label)
                            div
                              div.text-md.font-medium.neutral700--text Percentage discount (%)
                              div.text-sm.font-normal.neutral700--text Make a discount based on percentage of the full price
                        template(v-if="offer.reward_type && offer.reward_type === 'discount_percentage'")
                          v-text-field.text-sm.mt-2.round-xl.pl-8(v-model="offer.discount_percentage" placeholder="0.0" outlined dense height="48" :rules="rules.not_empty" suffix="%" type="number" hide-details="auto")
                    v-row(no-gutters)
                      v-col(cols="6")
                        v-radio.mt-3(value="discount_amount" color="neutral700")
                          template(v-slot:label)
                            div
                              div.text-md.font-medium.neutral700--text Fixed amount discount (RM)
                              div.text-sm.font-normal.neutral700--text Make a discount based on a fixed amount
                        template(v-if="offer.reward_type && offer.reward_type === 'discount_amount'")
                          v-text-field.text-sm.mt-2.round-xl.pl-8(v-model="offer.discount_amount" placeholder="0.00" outlined dense height="48" :rules="rules.not_empty" :prefix="$currency.symbol" type="number" hide-details="auto")
                    v-row(no-gutters)
                      v-col(cols="6")
                        v-radio.mt-3(value="free_item" color="neutral700")
                          template(v-slot:label)
                            div
                              div.text-md.font-medium.neutral700--text Free
                              div.text-sm.font-normal.neutral700--text Give free inventory/services/visit/other item
                    v-row(no-gutters)
                      v-col(cols="10")
                        template(v-if="offer.reward_type && offer.reward_type === 'free_item'")
                          div.ml-8
                            v-row
                              v-col(cols="6")
                                y-select.mt-2(v-model="offer.free_item_type" placeholder="Select reward" attach :items="[{ text: 'Applied inventory and services', value: 'product' }, { text: 'Visit', value: 'visit' }, { text: 'Other item', value: 'other' }]" item-text="text" item-value="value" :rules="rules.not_empty_select" @change="sanitizeUnusedObject(['free_item_name'], ['free_products'])")
                              v-col(v-if="offer.free_item_type && offer.free_item_type === 'other'")
                                v-text-field.text-sm.mt-2.round-xl(v-model="offer.free_item_name" placeholder="Enter item name" outlined dense height="48" :rules="rules.not_empty" hide-details="auto")
                    div.ml-8(v-if="offer.reward_type && offer.reward_type === 'free_item' && offer.free_item_type && offer.free_item_type === 'product'")
                      inventory-services-selection(v-model="offer.free_products")
                  //- How to redeem
                  v-row.mt-5
                    v-col(cols="6")
                      div.text-md.font-semibold.neutral700--text How to redeem
                      div.text-sm.neutral700--text(style="margin-top: 2px;") Set on how your customer will redeem this offer
                      v-radio-group.mt-0(v-model="offer.redeem_method" @change="sanitizeUnusedObject(['coupon_code'])")
                        v-radio.mt-3(value="general_code" color="neutral700" style="align-items: unset;")
                          template(v-slot:label)
                            div.text-md.font-medium.neutral700--text Create general coupon code
                        template(v-if="offer.redeem_method && offer.redeem_method === 'general_code'")
                          v-text-field.text-sm.mt-2.round-xl.pl-8(v-model="offer.coupon_code" placeholder="Enter your code here" outlined dense height="48" :rules="rules.not_empty" hide-details="auto")
                        v-radio.mt-3(value="unique_code" color="neutral700")
                          template(v-slot:label)
                            div.text-md.font-medium.neutral700--text Generate unique coupon code for every customer
                //- Applies to
                template(v-if="marketingSetting.plan === 'standalone'")
                  connect-to-checkout
                template(v-else)
                  v-card.round-xl.content-box.pa-6.mt-4(outlined)
                    div.text-md.font-semibold.neutral700--text Applies to
                    v-row(no-gutters)
                      v-col(cols="6")
                        v-radio-group.mt-0(v-model="offer.upon_any_purchase" @change="sanitizeUnusedObject(null,['purchase_products'])")
                          v-radio.mt-3(:value="true" color="neutral700")
                            template(v-slot:label)
                              div.text-md.font-medium.neutral700--text All inventory & services
                          v-radio.mt-3(:value="false" color="neutral700" style="align-items: unset;")
                            template(v-slot:label)
                              div.text-md.font-medium.neutral700--text Specific inventory & services
                    template(v-if="offer.hasOwnProperty('upon_any_purchase') && !offer.upon_any_purchase")
                      inventory-services-selection(v-model="offer.purchase_products")
                //- Expiry duration
                v-card.round-xl.content-box.pa-6.mt-4(outlined)
                  div.text-md.font-semibold.neutral700--text Expiry duration
                  div.text-sm.neutral700--text(style="margin-top: 2px;") Set active period for this offer
                  v-row.mt-5(dense)
                    v-col(cols="2")
                      v-text-field.text-sm.round-xl(v-model="offer.end_after_value" placeholder="Enter value" outlined dense height="48" type="number" :rules="rules.not_empty" hide-details="auto")
                    v-col(cols="2")
                      y-select(v-model="offer.end_after_unit" placeholder="Select duration" attach menuPosition="top" :items="duration" item-text="text" item-value="value" :rules="rules.not_empty_select" @change="sanitizeUnusedObject(['free_item_name'], ['free_products'])")
                    v-col(cols="2")
                      div.text-md.neutral700--text.mt-3 after offer sent
                //- Send offer message
                v-card.round-xl.content-box.pa-6.mt-4(outlined)
                  div.text-md.font-semibold.neutral700--text Send offer message
                  template(v-if="['First purchase', 'Second purchase'].includes(offer.name)")
                    v-radio-group.mt-0(v-model="sendDelaySelection.selectionType")
                      v-radio.mt-3(value="immediately" color="neutral700" style="align-items: unset;")
                        template(v-slot:label)
                          div.text-md.font-medium.neutral700--text Immediately after {{ offer.name.toLowerCase() }}
                      v-radio.mt-3(value="schedule_time" color="neutral700" style="align-items: unset;")
                        template(v-slot:label)
                          div.text-md.font-medium.neutral700--text Send message after
                      v-row.ml-6(v-if="sendDelaySelection.selectionType === 'schedule_time'" dense)
                        v-col(cols="2")
                          v-text-field.text-sm.round-xl(v-model="sendDelaySelection.timeValue" placeholder="Enter value" outlined dense height="48" type="number" :rules="rules.not_empty" hide-details="auto")
                        v-col(cols="2")
                          y-select(v-model="sendDelaySelection.timeUnit" placeholder="Select duration" attach menuPosition="top" :items="sendDelayDurations" item-text="text" item-value="value" :rules="rules.not_empty_select")
                      v-radio.mt-3(value="next_day_specific_time" color="neutral700" style="align-items: unset;")
                        template(v-slot:label)
                          div.text-md.font-medium.neutral700--text On next day after first purchase at
                      v-row.ml-6(v-if="sendDelaySelection.selectionType === 'next_day_specific_time'" dense)
                        v-col(cols="2")
                          v-text-field.text-sm.round-xl(v-model="sendDelaySelection.specificTime" placeholder="Enter value" outlined dense height="48" type="time" :rules="rules.not_empty" hide-details="auto")
                  template(v-else)
                    .text-sm.neutral700--text(v-if="offer.name === 'Birthday'") On the first day of birthday month
                    .text-sm.neutral700--text(v-if="offer.name === 'Reactivation'") Immediately after 60 days after last purchase
                //- SMS
                sms-offer-preset-delivery.mt-4(ref="smsOffer" :blast-data="method.sms" :send-delay-selection="sendDelaySelection" @resolved="fetchDeliveranceBlast")
                //- Email
                email-offer-preset-delivery.mt-4(ref="emailOffer" :blast-data="method.email" :send-delay-selection="sendDelaySelection" @resolved="fetchDeliveranceBlast")
                //- WhatsApp
                whatsapp-offer-preset-delivery.mt-4(ref="whatsappOffer" :blast-data="method.whatsapp" :send-delay-selection="sendDelaySelection" @resolved="fetchDeliveranceBlast")

      v-divider
      v-card-actions.py-4.px-8.white
        v-spacer
        y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="sm" button-class="px-0" @click="goBack")
        y-button(label="Save" text-color="neutral100" color="neutral700" size="sm" dark :loading="isLoading" @click="saveData")

</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import InventoryServicesSelection from '@/components/clinic/marketing/InventoryServicesSelection.vue'
import DatePickerField from '@/components/clinic/marketing/DatePickerField.vue'
import ConnectToCheckout from "@/components/clinic/marketing/ConnectToCheckout.vue";
import SmsOfferPresetDelivery from "@/components/clinic/marketing/SmsOfferPresetDelivery.vue";
import EmailOfferPresetDelivery from "@/components/clinic/marketing/EmailOfferPresetDelivery.vue";
import WhatsappOfferPresetDelivery from "@/components/clinic/marketing/WhatsappOfferPresetDelivery.vue";

export default {
  components: {
    WhatsappOfferPresetDelivery,
    EmailOfferPresetDelivery,
    SmsOfferPresetDelivery,
    ConnectToCheckout,
    InventoryServicesSelection,
    DatePickerField
  },
  props: ['id'],
  data() {
    return {
      isFetching: true,
      isLoading: false,
      openSmsDialog: false,
      openEmailDialog: false,
      openWhatsappDialog: false,
      openTestSmsDialog: false,
      openTestWhatsappDialog: false,
      openTestEmailDialog: false,
      selectedData: null,
      method: {},
      methodSwitch: {},
      offer: {},
      duration: [
        {text: 'Hours', value: 'hours'},
        {text: 'Days', value: 'days'},
        {text: 'Weeks', value: 'weeks'},
        {text: 'Months', value: 'months'},
      ],
      sendDelayDurations: [
        {text: 'Seconds', value: 'seconds'},
        {text: 'Minutes', value: 'minutes'},
        {text: 'Hours', value: 'hours'},
        {text: 'Days', value: 'days'},
      ],
      sendDelaySelection: {
        selectionType: null,
        timeValue: 1,
        timeUnit: 'hours',
        specificTime: null
      },
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0 || `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required']
      },
      presets: [
        {
          id: 'FirstPurchase',
          name: this.$t('first_purchase'),
          subtitle: this.$t('first_purchase_subtitle'),
          contentHeader: this.$t('first_purchase_content_header'),
          contentDescription: this.$t('first_purchase_content_description'),
        },
        {
          id: 'SecondPurchase',
          name: this.$t('second_purchase'),
          subtitle: this.$t('second_purchase_subtitle'),
          contentHeader: this.$t('second_purchase_content_header'),
          contentDescription: this.$t('second_purchase_content_description'),
        },
        {
          id: 'Birthday',
          name: this.$t('birthday'),
          subtitle: this.$t('birthday_subtitle'),
          contentHeader: this.$t('birthday_content_header'),
          contentDescription: this.$t('birthday_content_description'),
        },
        {
          id: 'Reactivation',
          name: this.$t('reactivation'),
          subtitle: this.$t('reactivation_subtitle'),
          contentHeader: this.$t('reactivation_content_header'),
          contentDescription: this.$t('reactivation_content_description'),
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      displaySize: 'ui/getDisplaySize',
      marketingSetting: 'marketing/getMarketingSettings'
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    rewardStatus: {
      get() {
        return Boolean(this.offer?.status === 'active')
      },
      set(val) {
        if (val) {
          this.offer.status = 'active'
        } else {
          this.offer.status = 'draft'
        }
      }
    },
    viewHeight() {
      switch (this.displaySize) {
        case 'xx-small':
          return '130vh'
        case 'x-small':
          return '114vh'
        case 'small':
          return '106vh'
        case 'medium':
          return '92vh'
        case 'large':
          return '81vh'
        case 'x-large':
          return '81vh'
        default:
          return '81vh'
      }
    }
  },
  async mounted() {
    try {
      const allFetching = [this.fetchSettings(), this.fetchOffer(), this.fetchDeliveranceBlast()]
      await Promise.all(allFetching)
    } catch (error) {
      this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
    } finally {
      this.isFetching = false
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchOffer() {
      let params = {expand: 'purchase_products,free_products'}
      return this.$axios.get(`/marketing/${this.company.slug}/offers/${this.id}`, params)
          .then(resp => {
            let offer = resp.data
            if (offer.discount_amount) {
              offer.discount_amount = Number(offer.discount_amount) / this.$currency.multiplier
            }
            this.$store.commit('marketing/setOffer', offer)
            this.offer = offer
          })
    },
    handleSetDelaySelectionType(data) {
      if (data.auto_send_delay_time_value === 0 && data.auto_send_delay_time_unit === 'seconds') {
        this.$set(this.sendDelaySelection, 'selectionType', 'immediately')
        return
      }
      if (data.auto_send_delay_specific_time) {
        this.$set(this.sendDelaySelection, 'selectionType', 'next_day_specific_time')
        return
      }
      this.$set(this.sendDelaySelection, 'selectionType', 'schedule_time')
    },
    handleSetDelaySelectionData(data) {
      this.handleSetDelaySelectionType(data)
      this.$set(this.sendDelaySelection, 'timeValue', data.auto_send_delay_time_value)
      this.$set(this.sendDelaySelection, 'timeUnit', data.auto_send_delay_time_unit)
      this.$set(this.sendDelaySelection, 'specificTime', data.auto_send_delay_specific_time)
    },
    fetchDeliveranceBlast() {
      return this.$axios.get(`/marketing/${this.company.slug}/offers/${this.id}/blasts`)
          .then(resp => {
            let blasts = resp.data.results
            if (blasts.find(f => f.method === 'sms')) {
              let data = blasts.find(f => f.method === 'sms')
              this.$set(this.method, 'sms', data)
              this.$set(this.methodSwitch, 'sms', data.enabled)
              // Get only sms blast data for delay selection, all others will have same values
              this.handleSetDelaySelectionData(data)
            }
            if (blasts.find(f => f.method === 'email')) {
              let data = blasts.find(f => f.method === 'email')
              this.$set(this.method, 'email', data)
              this.$set(this.methodSwitch, 'email', data.enabled)
            }
            if (blasts.find(f => f.method === 'whatsapp')) {
              let data = blasts.find(f => f.method === 'whatsapp')
              this.$set(this.method, 'whatsapp', data)
              this.$set(this.methodSwitch, 'whatsapp', data.enabled)
            }
          })
    },
    fetchSettings() {
      return this.$axios.get(`/marketing/${this.company.slug}`)
          .then(resp => {
            this.$store.commit('marketing/setMarketingSettings', resp.data)
          })
    },
    sanitizeUnusedObject(strings, arrays) {
      if (strings && strings.length) {
        strings.forEach(f => {
          if (this.offer[f]) this.offer[f] = null
        })
      }
      if (arrays && arrays.length) {
        arrays.forEach(o => {
          if (this.offer[o]) this.offer[o] = []
        })
      }
    },
    validateData() {
      const isValidForm = this.$refs.form.validate()
      const isValidSms = this.$refs.smsOffer.validateData()
      const isValidEmail = this.$refs.emailOffer.validateData()
      const isValidWhatsapp = this.$refs.whatsappOffer.validateData()
      return isValidForm && isValidSms && isValidEmail && isValidWhatsapp
    },
    async handleSaveAll() {
      this.isLoading = true
      if (['First purchase', 'Second purchase'].includes(this.offer.name)) {
        this.handleSetPayloadDelaySelectionData()
      }
      const savingAll = [
        this.saveOffer(),
        this.$refs.smsOffer.saveData(),
        this.$refs.emailOffer.saveData(),
        this.$refs.whatsappOffer.saveData()
      ]
      try {
        await Promise.all(savingAll)
        this.$emit('updated')
        this.showMessage(['success', this.$t('success_message.preset_updated_successfully')])
        this.goBack()
      } catch (err) {
        let message = this.$t('error_message.unable_to_complete_request')
        if (err.response.data) {
          if (err.response.data.detail) {
            message = err.response.data.detail
          } else {
            let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
            if (data) {
              message = data
            }
          }
        }
        this.showMessage(['error', message])
      } finally {
        this.isLoading = false
      }
    },
    async handleSaveOfferDisabled() {
      this.isLoading = true
      try {
        const payload = {
          status: 'draft'
        }
        this.$axios.patch(`/marketing/${this.company.slug}/offers/${this.offer.id}`, payload)
        this.$emit('updated')
        this.showMessage(['success', this.$t('success_message.preset_updated_successfully')])
        this.goBack()
      } catch (err) {
        let message = this.$t('error_message.unable_to_complete_request')
        if (err.response.data) {
          if (err.response.data.detail) {
            message = err.response.data.detail
          } else {
            let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
            if (data) {
              message = data
            }
          }
        }
        this.showMessage(['error', message])
      } finally {
        this.isLoading = false
      }
    },
    async saveData() {
      if (this.offer.status === 'draft') {
        await this.handleSaveOfferDisabled()
        return
      }
      const isValid = this.validateData()
      if (!isValid) {
        this.showMessage(['error', this.$t('error_message.please_fill_out_all_required')])
        return
      }
      await this.handleSaveAll()
    },
    saveOffer() {
      let payload = {
        status: this.offer.status,
        upon_any_purchase: this.offer.upon_any_purchase,
        reward_type: this.offer.reward_type,
        discount_percentage: this.offer.discount_percentage,
        discount_amount: this.offer.discount_amount ? Math.round(Number(this.offer.discount_amount) * this.$currency.multiplier) : null,
        free_item_type: this.offer.free_item_type,
        redeem_method: this.offer.redeem_method,
        coupon_code: this.offer.coupon_code,
        end_after_value: this.offer.end_after_value,
        end_after_unit: this.offer.end_after_unit,
      }
      payload.purchase_products = this.offer.purchase_products.map(m => m.id)
      payload.free_products = this.offer.free_products.map(m => m.id)
      return this.$axios.patch(`/marketing/${this.company.slug}/offers/${this.offer.id}`, payload)
    },
    goBack() {
      this.$router.push('/admin/clinic/marketing')
    },
    getPreset() {
      return this.presets.find(f => f.name === this.offer.name) || {}
    },
    handleSetPayloadDelaySelectionData() {
      if (this.sendDelaySelection.selectionType === 'immediately') {
        this.sendDelaySelection.timeValue = 0
        this.sendDelaySelection.timeUnit = 'seconds'
        this.sendDelaySelection.specificTime = null
        return
      }
      if (this.sendDelaySelection.selectionType === 'next_day_specific_time') {
        this.sendDelaySelection.timeValue = 1
        this.sendDelaySelection.timeUnit = 'days'
        return
      }
      this.sendDelaySelection.specificTime = null
    }
  },
  beforeDestroy() {
    this.$store.commit('marketing/resetMarketingOffer')
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-data-table__wrapper table tbody tr:hover {
    cursor: pointer;
    background: var(--v-neutral200) !important;
  }

  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  }

  .error--text {
    color: var(--v-danger500) !important;

    fieldset {
      border-color: var(--v-danger500);
    }
  }

  .search-field {
    .v-input__append-inner {
      margin-top: 12px !important;
    }
  }
}
</style>